import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import { isApiResponse, isReportAccess, date_range_config,reactSelectStyles } from '../../helpers/utils.js';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
var date_config = date_range_config('1', '1', '2020-02-01','1');
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var timestamp  = new Date().getTime();
var download_count = 0;
class ProductErrorReportTest extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            months:"",
            monthValue:null,
            monthsLists:[],
            is_export: false,
            model_visible : false,
            file_url: '',
            rfile: '',
            is_record: true,
            download_count:1,
            total_count:'',
            show_count: false,
            dw_msg: "Downloading",
        }

    }

    componentWillMount() {
        this.props.currentMenu("unipaynext");

    }
    componentDidUpdate() {

    }

    componentDidMount() {

    }
    productErrorDownloadCheck1(){

        var postData = {
             start_date: this.state.yestSend,
             end_date: this.state.todSend,
             download: 0
        };

        let xhrBank = $.ajax({
            url: config.get('API_URL') + "/InternalReport/product_error_report_download_test",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
//             xhrFields: {
//                 responseType: 'blob'
//             },
            success: function (response, status, xhr) {
                    console.log("dadasaaa", response.data)
                    this.productErrorDownloadCheck();

            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }

    productErrorDownloadCheck(){
        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: '',
            fetch_data:false,
            download_count: 1,
            total_count: '',
            show_count: false,
            dw_msg: "Downloading"
        });
        download_count = 0;
        var postData = {
             start_date: this.state.yestSend,
             end_date: this.state.todSend,
             download: 1
        };

        let xhrBank = $.ajax({
            url: config.get('API_URL') + "/InternalReport/product_error_report_download_test",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
//             xhrFields: {
//                 responseType: 'blob'
//             },
            success: function (response, status, xhr) {
                console.log("2222222",response.data)
                this.setState({
                        total_count:response.data.length,
                        show_count: true
                    })
                response.data.map((path, index) => {
                    this.copyFile(path,index);

                });
                //this.copyFile(response.data);
                this.setState({
                    fetch_data:true,
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    copyFile (remotePath, index){
        var postData = {
            remotePath: remotePath
        }

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/copy-file",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp+'product_error_report_'+index+'.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                console.log(fileName)
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                window.URL.revokeObjectURL(url);
                download_count++;
                if(download_count===this.state.total_count){
                    this.setState({
                        dw_msg: "Downloaded"
                    })
                }
                this.setState({
                       download_count:download_count
//                     file_url: url,
//                     rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });


    }

    render() {


        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">

                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">

                                    <div className="clearfix"></div>
                                    <div className="row">
                                    <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                        <div><label> Date Filter: </label></div>
                                        <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                        start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                    </div>
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.productErrorDownloadCheck1.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>

                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        {this.state.fetch_data===false?
                                                        <p>Fetching Data & Generating CSV...</p>:null}
                                                        {this.state.show_count===true?
                                                <div>{this.state.dw_msg} {this.state.download_count}  of {this.state.total_count} reports</div>:null
                                            }
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         
       );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( ProductErrorReportTest);